import {getConfigValue} from '../libs/@elements/config-utils';
import 'url-search-params-polyfill'; // Edge Polyfill
import 'whatwg-fetch'; // IE10 Polyfill
import fetch from '../libs/@elements/fetch';
import {findAll, removeAttribute, setAttribute} from '../libs/@elements/dom-utils';
import throwError from "../libs/@elements/throw-error";
const configName = '_cartConfig';

let countEls = [];

const defaultSelectors = {
    count: '.js-cart-count'
};

export function init(selectors = defaultSelectors){
    countEls = findAll(selectors.count);

    const url = getConfigValue('cartInfoUrl', configName) || false;

    let pendingRequest = url ? fetch(url) : throwError('window["_cartConfig"] missing cartInfoUrl');
    pendingRequest.then((result) => {
        return result.clone().json()
    }).then((result) => {
        if (result.success) {
            if (typeof result.count !== "undefined") {
                setCount(countEls, result.count);
            }
        } else {
            throwError('request unsuccessful')
        }
    }).catch((error) => {
        if (error.name !== 'AbortError') {
            /*Do error stuff*/
            console.error(error);
            setCount(countEls, null);
        }
    });
}

function setCount(elements, count) {
    if (count) {
        elements.map((item) => {
            removeAttribute('hidden', item);
            item.textContent = count;
        });
    } else {
        elements.map((item) => {
            setAttribute('hidden', true, item);
        });
    }
}
